import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { toast } from "react-toastify";
import * as Yup from "yup";
import TextField from '../../../../core/common/textFields/TextField';
import Select, { StylesConfig } from "react-select";
import { DatePicker } from 'antd';
import { useCreateUpdateContigencyMutation, useGetAllActiveUsersQuery, useLazyGetContigencyByIdQuery } from '../../../../services/EndPointsApis';
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

const SidebarContigencies = ({ activityTogglePopup, closeSidebar, isEditing, refetch, contigencyId, viewOnly, projectLookups, setActivityToggleContigencies }: any) => {
    const [updateId, setUpdateId] = useState(0);
    dayjs.extend(customParseFormat);
    //createUpdateContigency
    const [createUpdateContigency, { data, isError, error, isSuccess, isLoading }] = useCreateUpdateContigencyMutation();
    //Active Users
    const { data: getallActiveUsers, refetch: activeUsersRefetch } = useGetAllActiveUsersQuery('');
    //get contigency by Id
    const [triggerContigencyData, { data: getContigencyById }] = useLazyGetContigencyByIdQuery();

    const params = useParams()
    const ProjectId = params?.projectId

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };

    const initialValues = {
        id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        projectId: ProjectId,
        active: true,
        lst_ContigencyType: {
            id: 0,
            value: ""
        },
        lst_AssignedTo: {
            id: 0,
            value: ""
        },
        lst_ResolvedBy: {
            id: 0,
            value: ""
        },
        dateCreated: "2024-10-30T08:22:58.103Z",
        dueDate: "2024-10-30T08:22:58.103Z",
        dateResolved: "2024-10-30T08:22:58.103Z",
        note: ""
    }
    const TeamSchema = Yup.object().shape({
        note: Yup.string()
            .required("Note is required"),
        lst_ContigencyType: Yup.object({
            id: Yup.number().min(1, 'Contingency Type must be selected').required('Contingency Type is required'),
        }).required(),
        lst_AssignedTo: Yup.object({
            id: Yup.number().min(1, 'Assigned To must be selected').required('Assigned To is required'),
        }).required(),
    })
    const formik = useFormik({
        validationSchema: TeamSchema,
        initialValues,
        onSubmit: (values) => {
            createUpdateContigency(values);
        },
    });

    const { resetForm } = formik;

    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            resetForm()
            formik.setValues(initialValues);
            setActivityToggleContigencies(false)
            refetch()
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error]);

    useEffect(() => {
        if (activityTogglePopup === true && isEditing === false) {
            resetForm();
            formik.setValues(initialValues);
        }
    }, [activityTogglePopup, isEditing]);

    useEffect(() => {
        if (contigencyId && isEditing===true) {
            triggerContigencyData({ Id: contigencyId, projectId: ProjectId })

        }
    }, [contigencyId, activityTogglePopup])

    useEffect(() => {
        if (isEditing===true && getContigencyById?.result && Object.keys(getContigencyById?.result).length > 0) {
            // setUpdateId(getContigencyById?.result?.leadProspectId);
            formik.setValues({ ...getContigencyById.result });
            // setDisabledata(true)
        } else {
            // setUpdateId(0);
        }
    }, [getContigencyById, isEditing]);

    const handleSubmit = () => {
        formik.handleSubmit()
    }
    const handleDateChange = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('dateCreated', date ? date.format('YYYY-MM-DD') : null);
    };
    const handledueDate = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('dueDate', date ? date.format('YYYY-MM-DD') : null);
    };
    const handledateResolved = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('dateResolved', date ? date.format('YYYY-MM-DD') : null);
    };
    return (
        <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                {/* <form onSubmit={formik.handleSubmit}> */}
                <div className="sidebar-header">
                    <h4>{isEditing ? "Edit a Contingency" : viewOnly === true ? 'View a Contingency' : "Add a Contingency"} </h4>
                    <Link to="#" className="sidebar-close toggle-btn" onClick={closeSidebar}>
                        <i className="ti ti-x" />
                    </Link>
                </div>
                <div className="toggle-body">
                    <div className="toggle-height">
                        <div className="pro-create">
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label className="input-label">
                                            Active
                                        </label>
                                        <label className="checkboxs mt-2 mb-5">
                                            <input
                                                type="checkbox"
                                                checked={formik.values.active}
                                                disabled={viewOnly}
                                                {...formik.getFieldProps("active")}
                                            />
                                            <span className="checkmarks" />
                                        </label>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-wrap">
                                            <label className="input-label">Contingency
                                                <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={projectLookups?.result?.Lst_Contigency?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                                value={
                                                    formik.values?.lst_ContigencyType
                                                        ? {
                                                            value: formik.values?.lst_ContigencyType?.id,
                                                            label: formik.values?.lst_ContigencyType?.value || '',
                                                        }
                                                        : null
                                                }
                                                isDisabled={viewOnly}
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue('lst_ContigencyType.id', selectedOption?.value);
                                                    formik.setFieldValue('lst_ContigencyType.value', selectedOption?.label);

                                                }}
                                            />
                                            {formik.touched.lst_ContigencyType && formik.errors.lst_ContigencyType && (
                                                <div className="error">{formik.errors.lst_ContigencyType?.id}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-wrap">
                                            <label className="input-label">Assigned To
                                                <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={getallActiveUsers?.result?.map((option: any) => ({
                                                    label: option?.userName,
                                                    value: option?.userId
                                                }))}
                                                value={
                                                    formik.values?.lst_AssignedTo
                                                        ? {
                                                            value: formik.values?.lst_AssignedTo?.id,
                                                            label: formik.values?.lst_AssignedTo?.value || '',
                                                        }
                                                        : null
                                                }
                                                isDisabled={viewOnly}
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue('lst_AssignedTo.id', selectedOption?.value);
                                                    formik.setFieldValue('lst_AssignedTo.value', selectedOption?.label);
                                                }}
                                            />
                                            {formik.touched.lst_AssignedTo && formik.errors.lst_AssignedTo && (
                                                <div className="error">{formik.errors.lst_AssignedTo?.id}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-wrap">
                                            <label className="input-label">Resolved By
                                                {/* <span className="text-danger">*</span> */}
                                            </label>
                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={getallActiveUsers?.result?.map((option: any) => ({
                                                    label: option?.userName,
                                                    value: option?.userId
                                                }))}
                                                value={
                                                    formik.values?.lst_ResolvedBy
                                                        ? {
                                                            value: formik.values?.lst_ResolvedBy?.id,
                                                            label: formik.values?.lst_ResolvedBy?.value || '',
                                                        }
                                                        : null
                                                }
                                                isDisabled={viewOnly}
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue('lst_ResolvedBy.id', selectedOption?.value);
                                                    formik.setFieldValue('lst_ResolvedBy.value', selectedOption?.label);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <label className="input-label ">
                                            Date Created
                                            {/* <span className="text-danger">*</span> */}
                                        </label>
                                        <div className="form-wrap icon-form">
                                            <span className="form-icon">
                                                <i className="ti ti-calendar-check" />
                                            </span>
                                            <DatePicker
                                                className="form-control datetimepicker deals-details "
                                                // selected={selectedFreshAptmentDate}
                                                onChange={handleDateChange}
                                                value={formik.values?.dateCreated ? dayjs(formik.values?.dateCreated, 'YYYY-MM-DD') : null}
                                                format="MMM-DD-YYYY"
                                                disabled
                                            />
                                        </div>a
                                    </div>
                                    <div className="col-md-12">
                                        <label className="input-label ">
                                            Due  Date
                                        </label>
                                        <div className="form-wrap icon-form">
                                            <span className="form-icon">
                                                <i className="ti ti-calendar-check" />
                                            </span>
                                            <DatePicker
                                                className="form-control datetimepicker deals-details "
                                                // selected={selectedFreshAptmentDate}
                                                onChange={handledueDate}
                                                value={formik.values?.dueDate ? dayjs(formik.values?.dueDate, 'YYYY-MM-DD') : null}
                                                format="MMM-DD-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <label className="input-label ">
                                            Date Resolved
                                        </label>
                                        <div className="form-wrap icon-form">
                                            <span className="form-icon">
                                                <i className="ti ti-calendar-check" />
                                            </span>
                                            <DatePicker
                                                className="form-control datetimepicker deals-details "
                                                // selected={selectedFreshAptmentDate}
                                                onChange={handledateResolved}
                                                value={formik.values?.dateResolved ? dayjs(formik.values?.dateResolved, 'YYYY-MM-DD') : null}
                                                format="MMM-DD-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <TextField
                                            label='Note'
                                            required
                                            {...formik.getFieldProps('note')}
                                        />
                                        {formik.touched.note && formik.errors.note && (
                                            <div className="error">{formik.errors.note}</div>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="submit-button text-end">
                            <button className="btn btn-light sidebar-close" onClick={closeSidebar}>
                                Cancel
                            </button>
                            {viewOnly ? (<>

                            </>) : (<>
                                <button
                                    className="btn btn-primary"
                                    type='submit'
                                    onClick={handleSubmit}
                                >
                                    {isEditing ? "Update" : "Add"}
                                </button>
                            </>)}

                        </div>
                    </div>
                </div>
                {/* </form> */}
            </div>
        </div>
    );
};

export default SidebarContigencies;
